<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CHỈNH SỬA ĐIỂM</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pb-6 pt-0">
        <v-form v-bind="this.$attrs">
          <div>
            <div v-for="(mark, index) in marks" :key="mark.id">
              <div class="px-0 pt-6">
                <div class="d-flex">
                  <div class="pb-6 d-flex" style="flex-grow: 1">
                    <v-text-field
                      :label="`Điểm ${mark.name} hiện tại`"
                      v-model="mark.value"
                      outlined
                      disabled
                      hide-details
                      class="pr-6"
                      style="flex-grow: 1"
                    ></v-text-field>
                    <v-text-field
                      :label="`Điểm ${mark.name} sau phúc khảo`"
                      v-model="mark.reviewedValue"
                      outlined
                      hide-details
                      style="flex-grow: 1"
                    ></v-text-field>
                  </div>
                </div>
              </div>
              <v-divider v-if="index < marks.length - 1"></v-divider>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean,
    profile: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.setFormValues(newProfile)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      marks: []
    }
  },
  methods: {
    ...mapActions('examMark', ['updateMark']),

    close() {
      this.$emit('closeDialog')
    },

    async submit() {
      this.$loading.active = true
      try {
        const updatePromises = this.marks.map(mark =>
          this.updateMark({ id: mark.id, reviewedValue: mark.reviewedValue })
        )
        await Promise.all(updatePromises)
        this.$emit('refresh')
        this.close()
      } catch (error) {
        console.error('Error updating marks:', error)
      } finally {
        this.$loading.active = false
      }
    },
    setFormValues(profile) {
      if (this.profile && this.profile.marks) {
        this.marks = profile.marks.map(mark => ({
          ...mark,
          name: mark.name,
          reviewedValue: mark.reviewedValue || mark.value
        }))
      }
    }
  }
}
</script>
